
































// eslint-disable-next-line no-unused-vars
import { Domain, SslCertificate } from "@/types/domain";
import DateUtils from "@/utils/dayjs";
import dayjs from "dayjs";
import { Component, Prop, Mixins } from "vue-property-decorator";
@Component({})
export default class TableWidget extends Mixins(DateUtils) {
	@Prop({ required: true })
	title!: string;
	@Prop({ required: true })
	domains!: Array<Domain>;
	@Prop({ required: false, default: "No data to display" })
	noDataPresentMessage!: string;
	@Prop({ required: false, default: false })
	showDaysLeft!: boolean;
	@Prop({ required: false, default: false })
	showBubble!: boolean;

	findCertificateExpiring(domain: Domain): SslCertificate | undefined {
		let certificateExpiring: SslCertificate | undefined = domain.sslCertificates.find(
			(certificate) => {
				return this.dateIsBetweenBounds(dayjs(certificate.expires).toDate(), 1, 30);
			}
		);

		return certificateExpiring;
	}

	findExpiredCertificate(domain: Domain): SslCertificate | undefined {
		let expiredCertificate: SslCertificate | undefined = domain.sslCertificates.find(
			(certificate) => {
				return dayjs(certificate.expires!).isBefore(new Date());
			}
		);
		return expiredCertificate;
	}
}
